module.exports = __webpack_public_path__ + "static/media/preview.e0643f05.webp";